import { useTranslation } from 'next-i18next'
import { CATEGORY_ICONS } from './product_details/icons'
import { PRODUCT_DETAILS_CATEGORY_COMPONENTS } from './product_details/components'

interface Props {
  product: Product
}

export function ProductDetails({ product }: Props) {
  const { t } = useTranslation('common')
  return (
    <div className="flex flex-col gap-4">
      <div
        className="flex flex-col items-stretch justify-start gyg-widget-copy gap-2"
        style={{ paddingBottom: '10px' }}
      >
        {['times', 'duration', 'languages', 'meeting_point'].map((infoKey) => {
          if (
            !product[infoKey as keyof typeof product] ||
            (Array.isArray(product[infoKey as keyof typeof product]) &&
              (product[infoKey as keyof typeof product] as any[]).length === 0)
          )
            return null
          return (
            <div
              key={infoKey}
              className="flex flex-col items-start justify-start gap-1 mb-1"
            >
              <div
                className={`text-sm font-medium text-primary flex items-center`}
              >
                <span
                  className={
                    CATEGORY_ICONS[infoKey as keyof typeof CATEGORY_ICONS]
                  }
                />
                <div className="ml-2">{t(infoKey)}</div>
              </div>
              <div className="text-sm">
                {PRODUCT_DETAILS_CATEGORY_COMPONENTS[
                  infoKey as keyof typeof PRODUCT_DETAILS_CATEGORY_COMPONENTS
                ](product[infoKey as keyof typeof product] as any)}
              </div>
            </div>
          )
        })}
        {!!product?.further_information?.filter((fi) => !!fi).length && (
          <div className={`flex flex-col items-start justify-start gap-1 mb-1`}>
            <div className="text-sm font-medium text-primary flex items-center">
              <span className={CATEGORY_ICONS['further_information']} />
              <span className="ml-2">{t('further_information')}</span>
            </div>
            <div className="text-sm">
              {PRODUCT_DETAILS_CATEGORY_COMPONENTS['further_information'](
                product.further_information,
              )}
            </div>
          </div>
        )}
        {!!product?.inclusions?.filter((fi) => !!fi).length && (
          <div className={`flex flex-col items-start justify-start gap-1 mb-1`}>
            <div className="text-sm font-medium text-primary flex items-center">
              <span className={CATEGORY_ICONS['inclusions']} />
              <span className="ml-2">{t('inclusions')}</span>
            </div>
            <div className="text-sm">
              {PRODUCT_DETAILS_CATEGORY_COMPONENTS['inclusions'](
                product.inclusions,
              )}
            </div>
          </div>
        )}
      </div>
      {!!['tickets', 'cancellation_rebook'].filter((infoKey) => {
        const value = product[infoKey as keyof typeof product]
        return value && (!Array.isArray(value) || value.length > 0)
      })?.length && (
        <div
          className="flex flex-col items-stretch justify-start gyg-widget-copy gap-2"
          style={{ paddingBottom: '10px' }}
        >
          {['tickets', 'cancellation_rebook'].map((infoKey) => {
            if (
              !product[infoKey as keyof typeof product] ||
              (Array.isArray(product[infoKey as keyof typeof product]) &&
                (product[infoKey as keyof typeof product] as any[]).length ===
                  0)
            )
              return null
            return (
              <div
                key={infoKey}
                className="flex flex-col items-start justify-start gap-1 mb-1"
              >
                <div
                  className={`text-sm font-medium text-success flex items-center`}
                >
                  <span
                    className={
                      CATEGORY_ICONS[infoKey as keyof typeof CATEGORY_ICONS]
                    }
                  />
                  <div className="ml-2">{t(infoKey)}</div>
                </div>
                <div className="text-sm">
                  {PRODUCT_DETAILS_CATEGORY_COMPONENTS[
                    infoKey as keyof typeof PRODUCT_DETAILS_CATEGORY_COMPONENTS
                  ](product[infoKey as keyof typeof product] as any)}
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
